import React, { useState } from 'react';
import { Link , useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import './jobdescription.css'
import bullet from '../../../../images/bullet.svg'

function JobDescription() {
  

 

  const navigate = useNavigate();


  return (
    <div >
      <EmployerNavbar/>
      <Container fluid className='p-3 p-sm-5'>
      <div className='d-flex align-items-center text-center  gap-4 '>
    <FaArrowLeft className='arrow' onClick={() => navigate("/postjobs")} />
  <h3 className='mt-4'>Job Details</h3>
   </div>
   <div className='job-detail-info mt-5'>
     <p>Job Title: &nbsp;<span>Full-Stack Developer</span></p>
     <p>Job Category: &nbsp;<span>Software Development</span></p>
     <p>Monthly Salary Range: &nbsp;<span>500,000 - 700,000</span></p>
   </div>
   <div className='mt-5 p-3 job-detail-contain'>
   <div className='gap-3 mb-4'>
    <h6 className='label'>Job Description</h6>
    <p className=''> We need a software developer who has not less than 5 years experience using Javascript, MySQL and NodeJS. The candidate should be a team player and ready to assist when required. </p>
   </div>
   <div  className='gap-3 mb-4'>

   <h6 className='label'>Responsibilities</h6>
   <div className='gap-2'>
     <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>Write and deliver clean code</p>
     </div>
   
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>Lead a team of 5 Junior developers </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>Report to the Head, IT  </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p> Organise daily stand-up and submit reports </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p> Ship code and push to GIT </p>
   </div>
   </div>
   </div>
   <div  className='gap-3 mb-4'>

   <h6 className='label'>Qualifications/ Requirements</h6>
   <div className='gap-2'>
     <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>Undergraduate degree in Computer Science, Information Technology or similar disciplines</p>
     </div>
   
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>
Must have minimum 5 years experience in software development (Added advantage: Team Lead)

 </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p>Practical knowledge of JavaScript stack, GitHub, MySQL.
 </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p> Spoken and Written English proficiency
 </p>
   </div>
   <div className='d-flex align-items-center gap-2'><img src={bullet}/>
     <p> Proficient communicator </p>
   </div>
   </div>
   </div>
   <div className='d-flex mb-3'>
    <h6 className='label'>Job Type: &nbsp; </h6><span>Full-Time</span>
   </div>
   <div className='d-flex mb-3'>
    <h6 className='label'>Work-Place Type: &nbsp;</h6>
    <span>Hybrid</span>
   </div>
   <div className='d-flex mb-3'>
    <h6 className='label'>Location: &nbsp;</h6><span>Lagos, Nigeria</span>
   </div>
   </div>
    <div className='d-flex gap-3 align-items-center justify-content-center text-center mt-5 mb-3'>
      <Link to='/feedback' className='apply-btn text-decoration-none'> Post Job</Link>
      <Link to='/postjobs' className='save-btn text-decoration-none'> Edit</Link>
    </div>
    
      
    </Container>

    </div>
  
  );
}

export default JobDescription;

